export const LANGUAGE_NAME = "language_name";
export const CANCEL_ORDER_LAST_ACTIVE_TIME = "cancelOrderLastActiveTime";
